exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".has-error {\n  color: #f5222d;\n}\n.has-error .banner-media__container {\n  border: 1px solid #f5222d;\n}\n", ""]);

// exports
